import script from "./LeadsAddView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsAddView.vue?vue&type=script&setup=true&lang=js"

import "./LeadsAddView.vue?vue&type=style&index=0&id=519eb457&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519eb457"]])

export default __exports__